import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import WorkflowCanvas from '../ui/WorkflowCanvas';
import { useTheme } from '../../context/ThemeContext';
import { motion } from 'framer-motion';

interface LayoutProps {
  children: React.ReactNode;
}

const SITE_URL = 'https://sharmachaitanya945.com';

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { themeConfig } = useTheme();
  const { pathname } = useLocation();

  // Keep the canonical URL in step with client-side routes (/contact, /terms…).
  useEffect(() => {
    const link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (link) link.href = `${SITE_URL}${pathname === '/' ? '/' : pathname.replace(/\/?$/, '')}`;
  }, [pathname]);

  return (
    <div className="wf-canvas wf-canvas-animated wf-glow-field relative min-h-screen text-ink-main">
      {/* Decorative animated node-graph background */}
      <WorkflowCanvas />

      <div className="relative z-10">
        <Header />
        <motion.main
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className={`${themeConfig.layout?.containerStyle}`}
        >
          {children}
        </motion.main>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
